import { LEGAL, PLACEHOLDERS } from "@/content/legalInfo";

export const F = ({ k }) =>
  LEGAL[k] ? <span>{LEGAL[k]}</span> : <span className="ph" data-testid={`legal-placeholder-${k}`}>[{PLACEHOLDERS[k]}]</span>;

export const Mail = () => <a href={`mailto:${LEGAL.email}`} className="text-amber-700 underline underline-offset-2">{LEGAL.email}</a>;

export const Sec = ({ id, title, children }) => (
  <section id={id} className="scroll-mt-24 border-t border-gray-200 pt-8 mt-8 first:border-0 first:pt-0 first:mt-0">
    <h2>{title}</h2>
    {children}
  </section>
);

export const Info = ({ rows }) => (
  <dl className="mt-3 rounded-xl border border-gray-200 bg-white divide-y divide-gray-100 overflow-hidden">
    {rows.map(([label, value]) => (
      <div key={label} className="grid sm:grid-cols-[220px_1fr] gap-1 sm:gap-4 px-4 py-3 text-sm">
        <dt className="font-medium text-gray-500">{label}</dt>
        <dd className="text-gray-900 break-words">{value}</dd>
      </div>
    ))}
  </dl>
);

export const Bullets = ({ items }) => <ul>{items.map((i) => <li key={i}>{i}</li>)}</ul>;
